import styles from '../project-info-box/ProjectInfoBox.module.less';
import RoundedButtonAction from '../../../components/button/rounded-button-action/RoundedButtonAction';
import { formatMoneyKr, formatNumber, pluralize } from '../../../utils';
import Image from '../../../components/image/Image';

export const CartSupportButtons = ({ cartSum, cartCount, navigateToCart }) => {
    return (
        <div className={styles.supportWrapper}>
            <div className={styles.cartSumWrapper}>
                <span className={styles.cartCount}>
                    {formatNumber(cartCount)} {pluralize(cartCount, 'vare', 'varer')}
                </span>
                <span className={styles.cartSum}>Totalsum: {formatMoneyKr(cartSum)}</span>
            </div>
            <RoundedButtonAction
                trackingCategory={'shoppingcart-checkout'}
                trackingAction={'click'}
                className={styles.button}
                trackingParameters={{
                    'button-text': 'Støtt',
                    buttonType: 'main',
                }}
                onClick={navigateToCart}
            >
                <Image
                    src={'handlevogn.svg'}
                    alt={'Handlevogn-logo'}
                    role={'presentation'}
                    className={styles.handlevogn}
                />
                Gå&nbsp;til&nbsp;kassen
            </RoundedButtonAction>
        </div>
    );
};
